import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CancelVentaResponse {
  ventaId: string;
  numeroVenta: string;
  mensaje: string;
  detalles: {
    stockRevertido: boolean;
    cuentaCorrienteRevertida: boolean;
    pagoCajaRevertido: boolean;
    feAnulada: string;
  };
  nceGenerada: {
    idDE: string;
    cdc: string;
    numeroDE: string;
    kudeBase64: string;
  } | null;
}

export async function cancelVentaConFE(id: string): Promise<CancelVentaResponse> {
  await sleep(1000);
  const response = await api.put("ventas/" + id + "/anular-con-fe");
  return response.data.data;
}

export function useCancelVentaConFEMutation(id: string, mutationConfig: MutationConfig<CancelVentaResponse> = {}) {
  const queryClient = useQueryClient();
  return useMutation({
    ...mutationConfig,
    mutationFn: async () => await cancelVentaConFE(id),
    onSuccess: (...args) => {
      mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
      queryClient.invalidateQueries({ queryKey: ["ventas"] });
    },
  })
}

export interface CancelVentaConFEMutationProps {
  id: string,
  mutationConfig?: MutationConfig<CancelVentaResponse>,
  children?: (mutationResult: MutationResult<CancelVentaResponse>) => ReactNode
}

export function CancelVentaConFEMutation({
  id,
  children,
  mutationConfig
}: CancelVentaConFEMutationProps) {
  const mutationResult = useCancelVentaConFEMutation(id, mutationConfig);
  return children && children(mutationResult)
}
